import SectionHeading from './SectionHeading';
import { timelineHighlights, timelineYears } from '@/mocks/material';

export default function TimelineBand() {
  const max = Math.max(...timelineYears.map((y) => y.count));
  return (
    <section
      id="timeline"
      className="scroll-mt-24 border-y border-background-200/80 bg-background-100/50"
    >
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="02"
          kicker="往年档期"
          title="旧料回顾，按时间一路摊开"
          desc="从最早入档那年起，逐年排成一排档期。看密度能读出一年的热闹程度，点年份即翻到那一年的旧料回顾目录。"
          linkText="进入时间索引"
        />

        {/* 年份条形档期 */}
        <div className="mt-12 flex items-end gap-2 md:gap-4">
          {timelineYears.map((y) => (
            <button
              key={y.year}
              type="button"
              className="group flex flex-1 flex-col items-center gap-3"
            >
              <div className="flex w-full items-end justify-center">
                <span
                  className="w-full rounded-t-sm bg-secondary-200 transition-colors group-hover:bg-primary-400"
                  style={{ height: `${Math.round((y.count / max) * 130) + 28}px` }}
                />
              </div>
              <span className="font-heading text-sm font-bold text-foreground-800 group-hover:text-primary-600 md:text-base">
                {y.year}
              </span>
              <span className="hidden text-[11px] text-foreground-400 sm:block">
                {y.label} · {y.count}
              </span>
            </button>
          ))}
        </div>

        {/* 事件时间轴 */}
        <div className="mt-12 grid gap-8 lg:grid-cols-[1fr_1fr] lg:gap-12">
          <div>
            <h3 className="text-xs font-semibold tracking-[0.25em] text-primary-600">沿线关键节点</h3>
            <ol className="relative mt-6 space-y-0">
              {timelineHighlights.map((h, idx) => (
                <li key={idx} className="relative flex gap-4 pb-7 last:pb-0">
                  {idx < timelineHighlights.length - 1 && (
                    <span className="absolute left-[5px] top-5 h-full w-px bg-background-300" />
                  )}
                  <span className="mt-1.5 h-[11px] w-[11px] shrink-0 rounded-full border-2 border-accent-500 bg-background-50" />
                  <div className="flex flex-col gap-1">
                    <span className="font-heading text-sm font-bold text-accent-700">{h.time}</span>
                    <p className="text-sm leading-6 text-foreground-700">{h.event}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* 说明卡 */}
          <div className="flex flex-col justify-center">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-lg text-secondary-600" />
                <h3 className="font-heading text-lg font-bold text-foreground-950">档期怎么读</h3>
              </div>
              <ul className="mt-5 space-y-4 text-sm leading-6 text-foreground-600">
                <li className="flex gap-3">
                  <span className="mt-0.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary-400" />
                  条形越高 = 这一年入档越密，热闹程度一眼可比。
                </li>
                <li className="flex gap-3">
                  <span className="mt-0.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-400" />
                  线上圆点 = 当年发生过、如今还悬着争议的关键节点。
                </li>
                <li className="flex gap-3">
                  <span className="mt-0.5 h-1.5 w-1.5 shrink-0 rounded-full bg-secondary-400" />
                  年份标“归档” = 已整理成册，可整年翻取，不再零散。
                </li>
              </ul>
              <button
                type="button"
                className="mt-7 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-secondary-400 hover:text-secondary-700"
              >
                翻到最近归档年
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}